import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../store'
const moment = require('moment')

const feedback = () => import('@/components/feedback/feedback.vue')
const confirmacao = () => import('@/components/confirmacao/confirmacao.vue')
const previa = () => import('@/components/previa/previa.vue')
const alreadySent = () => import('@/components/alreadySent/alreadySent.vue')
const sentCanceled = () => import('@/components/sentCanceled/sentCanceled.vue')
const scheduleInvalid = () => import('@/components/scheduleInvalid/scheduleInvalid.vue')
const cancelarEnvio = () => import('@/components/cancelarEnvio/cancelarEnvio.vue')
const Login = () => import('@/components/login/')
const Cadastro = () => import('@/components/cadastro/')
const ValidaEmail = () => import('@/components/ValidaEmail')

// Dashboard
const Expirado = () => import('@/components/painel/expirado')
const Painel = () => import('@/components/painel/')
const agendamento = {
  painel: () => import('@/components/painel/agendamento/'),
  agendados: () => import('@/components/painel/agendamento/agendados'),
  pendentes: () => import('@/components/painel/agendamento/pendentes'),
  concluidos: () => import('@/components/painel/agendamento/concluidos'),
  cancelados: () => import('@/components/painel/agendamento/cancelados')
}
const PInicio = () => import('@/components/painel/inicio/')
const PConta = () => import('@/components/painel/conta/')
const pedidos = {
  painel: () => import('@/components/painel/pedidos'),
  novos: () => import('@/components/painel/pedidos/novos'),
  andamento: () => import('@/components/painel/pedidos/andamento'),
  concluidos: () => import('@/components/painel/pedidos/concluidos'),
  cancelados: () => import('@/components/painel/pedidos/cancelados')
}
const POrcamentos = () => import('@/components/painel/orcamentos/')
const PItens = () => import('@/components/painel/itens/')
const PNegocios = () => import('@/components/painel/negocios/')
const PAtendimento = () => import('@/components/painel/atendimento/')
const PRelatorios = {
  painel: () => import('@/components/painel/relatorios/index'),
  pedidos: () => import('@/components/painel/relatorios/pedidos/')
  // itens: () => import('@/components/painel/relatorios/itens/')
}

// Sub rotas
const Manutencao = () => import('@/components/manutencao')
const Relacao = () => import('@/components/painel/itens/relacao')
const Cupons = () => import('@/components/painel/itens/cupons')
const Empresa = () => import('@/components/painel/conta/empresa')
const Avaliacoes = () => import('@/components/painel/conta/avaliacoes')
const Usuarios = () => import('@/components/painel/conta/usuarios')

const hotsite = () => import('@/components/hotsite/')
const Cupom = () => import('@/components/hotsite/Cupom')
const Checkin = () => import('@/components/hotsite/Checkin')
const Checkout = () => import('@/components/hotsite/Checkout')
const Confirm = () => import('@/components/hotsite/Confirm')
const Success = () => import('@/components/hotsite/Success')

Vue.use(Router)

function getCookie (cname) {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
function registrationCompleted (to, from, next) {
  if (!store.getters.registrationCompleted) {
    store.commit('toastr', {
      color: 'info',
      texto: 'Complete seu cadastro para acessar este recurso'
    })
  } else {
    requireAuth(to, from, next)
  }
}
let resource = false
function resourceAvaliable (to, from, next) {
  if (resource) {
    requireAuth(to, from, next)
  } else {
    store.commit('toastr', {
      color: 'info',
      texto: 'Recurso não disponível'
    })
  }
}
function requireAuth (to, from, next) {
  if (store.getters.autenticacao) {
    next()
  } else {
    let validity = getCookie('tokenValidade')
    if (validity !== '') {
      store.dispatch('singOut', moment(validity).diff(moment()))
      store.commit('singIn', {
        nome: getCookie('tokenNome'),
        nivel: getCookie('tokenNivel'),
        token: getCookie('tokenAcesso'),
        status: getCookie('tokenStatus')
      })
      next()
    } else {
      next('/Login')
      store.commit('toastr', {
        color: 'error',
        texto: 'Você não está autenticado'
      })
    }
  }
}
function singIn (to, from, next) {
  if (getCookie('tokenValidade') === '') {
    next()
  } else {
    next('/Painel/Inicio/')
  }
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/Login',
      name: 'Login',
      beforeEnter: singIn,
      component: Login
    },
    {
      path: '/feedback/:token/:type/:send',
      name: 'feedback',
      props: true,
      component: feedback
    },
    {
      path: '/confirmacao/:token/:type',
      name: 'confirmacao',
      props: true,
      component: confirmacao
    },
    {
      path: '/previa/:token/:type/:send',
      name: 'previa',
      props: true,
      component: previa
    },
    {
      path: '/cancelarEnvio',
      name: 'cancelarEnvio',
      component: cancelarEnvio
    },
    {
      path: '/alreadySent/:token/:type',
      name: 'alreadySent',
      props: true,
      component: alreadySent
    },
    {
      path: '/sentCanceled/:token/:type',
      name: 'sentCanceled',
      props: true,
      component: sentCanceled
    },
    {
      path: '/scheduleInvalid/:token',
      name: 'scheduleInvalid',
      props: true,
      component: scheduleInvalid
    },
    {
      path: '/Expirado',
      name: 'Expirado',
      component: Expirado,
      props: true
    },
    {
      path: '/ValidaEmail/:token',
      name: 'Validação de email',
      component: ValidaEmail,
      props: true
    },
    {
      path: '/',
      beforeEnter: singIn,
      component: Login
    },
    {
      path: '/Cadastro',
      name: 'Cadastro Visitante',
      component: Cadastro
    },
    {
      path: '/A',
      component: hotsite,
      children: [
        {
          path: 'Cupom/:token/:type',
          name: 'Cupom',
          props: true,
          component: Cupom
        },
        {
          path: 'Servicos/:token',
          props: true,
          component: Checkin
        },
        {
          path: 'Confirmar',
          component: Confirm
        },
        {
          path: 'Sucesso',
          component: Success
        },
        {
          path: 'Checkout/:token',
          props: true,
          component: Checkout
        }
      ]
    },
    {
      path: '/Painel',
      name: 'Painel',
      beforeEnter: requireAuth,
      component: Painel,
      children: [
        {
          path: 'Conta',
          component: PConta,
          children: [
            {
              path: 'Empresa',
              component: Empresa
            },
            {
              path: 'Avaliacoes',
              component: Avaliacoes
            },
            {
              path: 'Usuarios',
              component: Usuarios
            },
            {
              path: 'Condominios',
              beforeEnter: resourceAvaliable,
              component: Manutencao
            },
            {
              path: 'Faturamento',
              beforeEnter: resourceAvaliable,
              component: Manutencao
            },
            {
              path: 'Planos',
              beforeEnter: resourceAvaliable,
              component: Manutencao
            }
          ]
        },
        {
          path: 'Inicio',
          beforeEnter: requireAuth,
          component: PInicio
        },
        {
          path: 'Agendamento',
          component: agendamento.painel,
          beforeEnter: registrationCompleted,
          children: [
            {
              path: 'Agendados',
              component: agendamento.agendados
            },
            {
              path: 'Pendentes',
              component: agendamento.pendentes
            },
            {
              path: 'Realizados',
              component: agendamento.concluidos
            },
            {
              path: 'Cancelados',
              component: agendamento.cancelados
            }
          ]
        },
        {
          path: 'Pedidos',
          component: pedidos.painel,
          beforeEnter: registrationCompleted,
          children: [
            {
              path: 'Novos',
              component: pedidos.novos
            },
            {
              path: 'Andamento',
              component: pedidos.andamento
            },
            {
              path: 'Concluidos',
              component: pedidos.concluidos
            },
            {
              path: 'Cancelados',
              component: pedidos.cancelados
            }
          ]
        },
        {
          path: 'Orcamentos',
          beforeEnter: registrationCompleted,
          component: POrcamentos
        },
        {
          path: 'Itens',
          beforeEnter: registrationCompleted,
          component: PItens,
          children: [
            {
              path: 'Relacao',
              component: Relacao
            },
            {
              path: 'Familia',
              component: Manutencao
            },
            {
              path: 'Cupons',
              component: Cupons
            }
          ]
        },
        {
          path: 'Negocios',
          beforeEnter: registrationCompleted,
          component: PNegocios
        },
        {
          path: 'Atendimento',
          beforeEnter: registrationCompleted,
          component: PAtendimento
        },
        {
          path: 'Relatorios',
          beforeEnter: registrationCompleted,
          component: PRelatorios.painel,
          children: [
            // {
            //   path: 'Itens',
            //   component: PRelatorios.itens
            // },
            {
              path: 'Condominios',
              component: PRelatorios.pedidos
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js